<div class="admin-container">
  <div class="destinations">
    <p-table
      #dTable
      [value]="destinations"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="true"
      [globalFilterFields]="['country']"
    >
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dTable.filterGlobal($event.target['value'], 'contains')"
              placeholder="Global Search"
            />
          </span>
          <button
            pButton
            label="Nouvelle destination"
            class="ml-auto"
            icon="pi pi-plus"
            iconPos="left"
            (click)="createDestination()"
          ></button>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Picture</th>
          <th pSortableColumn="country">
            Country
            <p-sortIcon field="country"></p-sortIcon>
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-destination>
        <tr>
          <td>
            <img
              [src]="baseUrl + destination.coverPicture.src"
              alt="destinationCoverPicture"
            />
          </td>
          <td>
            {{ destination.country }}
          </td>
          <td class="buttons">
            <button
              class="edit"
              pButton
              (click)="updateDestination(destination)"
              icon="pi pi-pencil"
            ></button>
            <!-- <button class="delete" pButton (click)="deleteArticle($event, article.id)" icon="pi pi-trash"
              iconPos="left">
            </button> -->
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-dialog [(visible)]="update" [style]="{ width: '30vw' }">
    <div class="modal" *ngIf="destinationModel">
      <form class="form">
        <div class="form-group">
          <label>Pays</label>
          <input
            type="text"
            pInputText
            [(ngModel)]="destinationModel.country"
            name="country"
          />
        </div>
        <div class="form-group">
          <label>Continent</label>
          <p-select
            [options]="[
              { label: 'Afrique', value: 'Afrique' },
              { label: 'Amérique', value: 'Amérique' },
              { label: 'Asie', value: 'Asie' },
              { label: 'Europe', value: 'Europe' },
              { label: 'Océanie', value: 'Océanie' }
            ]"
            [(ngModel)]="destinationModel.continent"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            name="continent"
          >
          </p-select>
        </div>
        <div class="form-group">
          <label>Description</label>
          <app-text-editor
            [(ngModel)]="destinationModel.description"
            [name]="destinationModel.id + 'description'"
          ></app-text-editor>
        </div>
        <div class="form-group">
          <label>Image de couverture</label>
          <input
            #coverPictureUpdate
            type="file"
            (change)="onFileChanged($event)"
          />
        </div>
        <div class="submit">
          <button pButton label="Annuler" (click)="update = false"></button>
          <button
            pButton
            label="Sauver"
            (click)="updateDestinationSave()"
          ></button>
        </div>
      </form>
    </div>
  </p-dialog>
</div>
